import React, { Component } from 'react'
import { branch, compose, renderComponent } from 'recompose'

import Loading from '../../atoms/Loading'
import MapWithSelectors from '../../organisms/MapWithSelectors'

class Mapa extends Component {
  render () {
    return <MapWithSelectors {...this.props} />
  }
}

const withLoadingComponent = branch(
  // props => props.loading,
  props => false,
  renderComponent(Loading)
)

export default compose(withLoadingComponent)(Mapa)



// WEBPACK FOOTER //
// ./src/components/templates/Mapa/Mapa.js